var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05346 4.88673C2.92012 4.88673 2.79346 4.8334 2.70012 4.74006L0.813457 2.8534C0.620124 2.66006 0.620124 2.34007 0.813457 2.14673C1.00679 1.9534 1.32679 1.9534 1.52012 2.14673L3.05346 3.68007L6.48012 0.253398C6.67346 0.0600651 6.99346 0.0600651 7.18679 0.253398C7.38012 0.446732 7.38012 0.766731 7.18679 0.960065L3.40679 4.74006C3.31346 4.8334 3.18679 4.88673 3.05346 4.88673Z",
    fill: "#6000E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.2d3fc4b13fe17fbe24a017b67d67efc7.svg";
export { ForwardRef as ReactComponent };